import styled from 'styled-components'
import { BackgroundLogoUnstyled } from './unstyled'
import images from 'Assets/Images'

export const BackgroundLogo = styled(BackgroundLogoUnstyled)`
  height: 100%;

  .background-image,
  .background-filter-1,
  .background-filter-2 {
    width: 100%;
    height: 100%;
    max-height: 100%;
  }

  .background-image {
    background: url(${images.authBackground}) no-repeat center;
    background-size: cover;
    position: relative;
  }

  .background-filter-1,
  .background-filter-2 {
    position: absolute;
  }

  .background-filter-1 {
    background: ${props => props.theme.colors.darkGray};
    opacity: 0.7;
  }

  .background-filter-2 {
    background: ${props => props.theme.colors.primary2};
    opacity: 0.3;
  }

  img {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
  }

  @media screen and (max-device-width: 400px), screen and (max-width: 400px) {
    img {
      margin: auto;
      display: block;
      position: static;
    }

    .background-image,
    .background-filter-1,
    .background-filter-2 {
      display: none;
    }
  }
`
